import { APIClient } from 'libs/oal/abstracts/apiClient';

/**
 * The app API client. It takes care of making all the requests.
 * @extends {APIClient}
 */
class AppAPI extends APIClient {
  /**
   * @param {HttpClient}       httpClient       The Aurelia's HTTP client, to make the requests.
   * @param {AppConfiguration} appConfiguration To get the API configuation.
   */
  constructor(httpClient, appConfiguration) {
    'inject';

    super(httpClient, appConfiguration.get('api'));
  }
  /**
   * Get the list of available products for the user.
   * @return {Promise<Object,Error>}
   */
  getProductsList() {
    return this.get(this.endpoint('products.list'));
  }
}

export { AppAPI };
